import { hasAccess, NavigationItem, ROUTES, UserRoles } from "../../../config/routes";
import NetworkHealthCard from "./cards/NetworkHealthCard";
import TitleQcCard from "./cards/TitleQcCard";
import BannerSwapCard from "./cards/BannerSwapCard";
import { SECONDARY_WIDGETS } from "./secondaryRegistry";
import { WidgetDefinition } from "./types";

/** Priority cards, in their default order. */
const PRIORITY_WIDGETS: WidgetDefinition[] = [
  {
    id: "title-qc",
    title: "Title QC",
    description: "Spelling fixes waiting for review",
    icon: "pi pi-check-square",
    accent: "#8e4ec6",
    path: ROUTES.METADATA_AUDIT_TITLE_QC,
    requiredTool: "MetadataAudit",
    supportsScope: true,
    mineLabel: "My channels",
    filterFields: [
      {
        key: "priorities",
        type: "multiselect",
        label: "Priority",
        options: [
          { label: "High", value: "high" },
          { label: "Secondary", value: "secondary" },
        ],
      },
      { key: "videoTypes", type: "multiselect", label: "Video type" },
      { key: "languages", type: "multiselect", label: "Channel language" },
    ],
    defaultFilters: { priorities: [], videoTypes: [], languages: [] },
    Component: TitleQcCard,
  },
  {
    id: "network-health",
    title: "Network Health Check",
    description: "Scorecard issues on YouTube videos",
    icon: "pi pi-heart",
    accent: "#e5484d",
    path: ROUTES.YOUTUBE_SCORECARD_METADATA,
    requiredTool: "YouTubeScorecard",
    supportsScope: true,
    mineLabel: "My channels",
    wide: true,
    filterFields: [
      {
        key: "categories",
        type: "multiselect",
        label: "Checks",
        placeholder: "Metadata and Claims & Ads",
        options: [
          { label: "Metadata & Properties", value: "metadata" },
          { label: "Claims & Ads", value: "claims" },
        ],
      },
      { key: "contentFormats", type: "multiselect", label: "Content format" },
      { key: "legalEntityTypes", type: "multiselect", label: "Legal entity type" },
    ],
    defaultFilters: { categories: [], contentFormats: [], legalEntityTypes: [] },
    Component: NetworkHealthCard,
  },
  {
    id: "banner-swap",
    title: "Banner Swap",
    description: "Scheduled and live channel banner swaps",
    icon: "pi pi-images",
    accent: "#0090ff",
    path: ROUTES.BANNER_DASHBOARD_SWAP_QUEUE,
    requiredTool: "BannerSwap",
    supportsScope: true,
    mineLabel: "My swaps",
    filterFields: [
      {
        key: "windowDays",
        type: "select",
        label: "Upcoming window",
        options: [
          { label: "Next 7 days", value: "7" },
          { label: "Next 14 days", value: "14" },
          { label: "Next 30 days", value: "30" },
        ],
      },
      {
        key: "includeManagedChannels",
        type: "toggle",
        label: "Include swaps on channels I manage",
        help: "Not just swaps I created",
      },
    ],
    defaultFilters: { windowDays: "7", includeManagedChannels: true },
    Component: BannerSwapCard,
  },
];

export const WIDGETS: WidgetDefinition[] = [...PRIORITY_WIDGETS, ...SECONDARY_WIDGETS];

/** Same access rules as the sidebar, so cards always match the menu. */
export const canSeeWidget = (def: WidgetDefinition, roles: UserRoles): boolean =>
  hasAccess(
    {
      label: def.title,
      path: def.path,
      icon: def.icon,
      requiredTool: def.requiredTool,
      requiredRole: def.requiredRole,
    } as NavigationItem,
    roles
  );

export const visibleWidgets = (roles: UserRoles): WidgetDefinition[] =>
  WIDGETS.filter((def) => canSeeWidget(def, roles));
